const vznesenePripomienkyNotFoundStatus = {
  loading: false,
  finished: true,
  responseCode: 404,
  failed: true,
  generalErrors: [
    {
      message: 'K  materiálu nie je pridaný žiadny dokument typu "Vznesené pripomienky v rámci '
        + 'pripomienkového konania."',
    }],
  fieldErrors: [],
};

export default vznesenePripomienkyNotFoundStatus;
